import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  Typography,
  useTheme,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import { withNamespaces } from "react-i18next";

import { ReactComponent as ThumbUpSvg } from "../../assets/thumb-up.svg";
import { ReactComponent as ThumbDownSvg } from "../../assets/thumb-down-red.svg";

import { ReactComponent as TelegramSvg } from "../../assets/telegram.svg";
import { ReactComponent as CheckMarkIconSvg } from "../../assets/certified.svg";
import { ReactComponent as ATagSvg } from "../../assets/atag.svg";

import { VOTE, toFixed, tokens } from "../../constants";
import bigInt from "big-integer";
import Status, { getStatusBarColor } from "../pools/components/Status";
import VoteModal from "../voting/components/voteModal";
import store from "../../stores/store";
import Web3 from "web3";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "100%",
    height: "100%",
    borderRadius: "30px",
    backgroundColor: theme?.colors.poolCard?.backgroundColor,
    boxShadow: "0px 3px 20px " + theme?.colors?.containerShadow,
    padding: "40px",
    fontFamily: "Poppins",
  },
  launchIcon: {
    position: "absolute",
    top: "20px",
    right: "20px",
    color: theme?.colors.poolCard?.title,
    cursor: "pointer",
    "&:hover": {
      opacity: "0.8",
    },
  },
  topPoolType: {
    width: "50%",
    minWidth: "80px",
    paddingLeft: "5px",
    paddingRight: "5px",
    height: "24px",
    borderRadius: "16px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme?.colors.poolCard?.poolTypeText,
    whiteSpace: "nowrap",
  },
  poolHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "25px",
  },
  poolImage: {
    width: "60px",
    height: "60px",
    marginRight: "20px",
  },
  logoContainer: {
    display: "flex",
    position: "relative",
  },
  badge: {
    position: "absolute",
    right: "-40px",
    width: "30px",
    height: "30px",
  },
  poolTitle: {
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    lineHeight: "30px",
    color: theme?.colors.poolCard?.title,
    cursor: "pointer",
    wordBreak: "break-all",

    position: "relative",
  },
  saleTitleStyle: {
    fontSize: "20px",
    fontWeight: "bold",
    lineHeight: "30px",
    color: theme?.colors.poolCard?.title,
    cursor: "pointer",
    wordBreak: "break-all",
    margin: "0px",
  },
  per1BNB: {
    fontSize: "15px",
    lineHeight: "18px",
    color: theme?.colors.poolCard?.perPrice,
    marginBottom: "8px",
  },
  saleValue: {
    fontSize: "25px",
    fontWeight: "normal",
    lineHeight: "30px",
    letterSpacing: "0px",
    textAlign: "left",
    color: theme?.colors.poolCard?.textSecondary,
    marginBottom: "15px",
  },
  saleStatusContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "25px",
  },
  salesStatusBarInnerContainer: {
    display: "flex",
    width: "100%",
    alignItems: "center",
  },
  salesStatusBar: {
    marginRight: "10px",
    width: "100%",
    height: "16px",
    borderRadius: "12px",
    backgroundColor: theme?.colors?.presale?.percentageBarBackground,
    marginBottom: "8px",
  },
  salesStatusSubBar: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
  },
  salesStatusBarFilled: {
    height: "16px",
    borderRadius: "12px",
  },
  salesStatusText: {
    fontSize: "15px",
    color: theme?.colors.poolCard?.statusBarLabel,
    whiteSpace: "nowrap",
    marginRight: "8px",
  },
  salesRequiredText: {
    fontSize: "15px",
    color: theme?.colors.poolCard?.statusBarLabel,
    marginBottom: "25px",
  },
  maximumConnectContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: "10px",
  },
  maximumWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  connectWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  connectText: {
    fontWeight: "normal",
    color: "#A0A0A0",
    margin: "0 0 8px",
  },
  maximumConnectLabel: {
    fontSize: "15px",
    lineHeight: "18px",
    color: theme?.colors.poolCard?.title,
    marginBottom: "8px",
  },
  maximumValue: {
    fontSize: "20px",
    lineHeight: "24px",
    color: theme?.colors.poolCard?.textSecondary,
  },
  connectIconsWrapper: {
    display: "flex",
    "& > *": {
      width: "24px",
      height: "24px",
      color: theme?.colors.poolCard?.linkIcon,
      marginRight: "20px",
      "&:hover": {
        color: theme?.colors.poolCard?.linkIconHover,
      },
      cursor: "pointer",
    },
  },
  thumbUpWrapper: {
    display: "flex",
    gap: "8px",
    margin: "0 0 16px 8px",
  },
  voteUpIcon: {
    width: "24px",
    height: "24px",
    cursor: "pointer",

    [theme.breakpoints.down("sm")]: {
      width: "18px",
      height: "18px",
    },

    "& > path": {
      fill: theme?.colors.poolCard?.linkIcon + "!important",
    },
  },
  voteDownIcon: {
    width: "24px",
    height: "24px",
    cursor: "pointer",

    [theme.breakpoints.down("sm")]: {
      width: "18px",
      height: "18px",
    },

    "& > path": {
      fill: theme?.colors.poolCard?.statusBarFilled["RED"] + "!important",
    },
  },

  currentPercText: {
    color: theme?.colors.poolCard?.textSecondary,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
    margin: "0 0 8px 0",
  },
  poolPercentageText: {
    color: theme?.colors?.poolCard?.statusBarLabel,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
  },
  maxText: {
    color: theme?.colors.poolCard?.textSecondary,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    backgroundColor: theme?.colors?.presale?.loadingBackground,
    zIndex: 4,
    position: "absolute",
    top: "0px",
    left: "0px",
  },
  loadingIcon: {
    zIndex: 5,
    color: theme?.colors?.presale?.loadingIcon,
    position: "absolute",
    top: "100px",
    left: "50%",
  },
  topPoolImage: {
    position: "absolute",
    top: "-36px",
    left: "calc(50% - 45px)",
    minWidth: "90px",
    paddingLeft: "5px",
    paddingRight: "5px",
    height: "90px",
    borderRadius: "50%",
    backgroundColor: theme?.colors?.poolCard?.background,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme?.colors.poolCard?.poolTypeText,
    whiteSpace: "nowrap",
  },
  poolDefaultImage: {
    zIndex: 4,
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    marginRight: "20px",
  },
  checkMarkIcon: {
    marginLeft: "8px",
    width: "20px",
    height: "20px",
    color: theme?.colors.poolCard?.linkIcon,
  },
});
const dispatcher = store.dispatcher;

const PoolCard = ({ classes, pool }) => {
  const totalCollected = parseFloat(
    toFixed(
      bigInt(pool.totalCollectedWei),
      tokens[pool?.fundingTokenAddress]?.decimals ?? 18,
      6
    )
  );
  const hardCap = parseFloat(
    toFixed(
      bigInt(pool.hardCapInWei),
      tokens[pool?.fundingTokenAddress]?.decimals ?? 18,
      6
    )
  );

  const tokenPrice = parseFloat(
    toFixed(
      bigInt(pool.tokenPriceInWei),
      tokens[pool?.fundingTokenAddress]?.decimals ?? 18,
      6
    )
  );

  const yesVotes = parseFloat(
    toFixed(
      bigInt(pool.yesVotes),
      tokens[pool?.fundingTokenAddress]?.decimals ?? 18,
      6
    )
  );
  const noVotes = parseFloat(
    toFixed(
      bigInt(pool.noVotes),
      tokens[pool?.fundingTokenAddress]?.decimals ?? 18,
      6
    )
  );

  const minYesVotesThreshold = parseFloat(
    toFixed(
      bigInt(pool.minYesVotesThreshold),
      tokens[pool?.fundingTokenAddress]?.decimals ?? 18,
      6
    )
  );

  const percentage = (totalCollected / hardCap) * 100;

  const history = useHistory();
  const fundingToken = tokens[pool?.fundingTokenAddress] || { label: "ETH" };

  const theme = useTheme();

  const fillBarColorId = getStatusBarColor(pool, theme);
  const web3 = new Web3();

  const [logoImage, setLogoImage] = useState("pools/default.png");

  const [showVoteModal, setShowVoteModal] = useState(false);

  useEffect(() => {
    const loadLogo = () => {
      try {
        const parsedLogo = web3.utils.hexToUtf8(pool.linkLogo);
        setLogoImage(parsedLogo);
      } catch (err) {
        setLogoImage(pool.linkLogo); // assume it's already parsed
      }
    };

    loadLogo();
  }, [pool.linkLogo, web3.utils]);

  const onVote = (voteChoice) => {
    dispatcher.dispatch({
      type: VOTE,
      content: {
        presaleIndex: pool.presaleIndex,
        voteType: voteChoice,
      },
    });
  };

  return (
    <div
      className={classes.root}
      onClick={() => {
        history.push(pool.url);
      }}
    >
      {!pool.saleTitle ||
        (!parseInt(pool.openTime) && (
          <div className={classes.loadingContainer}>
            <CircularProgress className={classes.loadingIcon} size={60} />
          </div>
        ))}
      <div className={classes.poolHeader}>
        <Typography variant="h3" className={classes.poolTitle}>
          <img
            className={classes.poolDefaultImage}
            src={logoImage}
            alt="pool"
            onError={(er) => {
              setLogoImage("pools/default.svg");
            }}
          />
          <p className={classes.saleTitleStyle}>
            {pool.saleTitle}
            <span>
              {pool.certified && (
                <Tooltip title="Certified BUIDLer">
                  <CheckMarkIconSvg className={classes.checkMarkIcon} />
                </Tooltip>
              )}
            </span>
          </p>
        </Typography>
      </div>
      <Typography variant="h5" className={classes.per1BNB}>
        {tokenPrice} {fundingToken?.label} Per Token
      </Typography>
      <Typography variant="h4" className={classes.saleValue}>
        {totalCollected > 0 &&
          `${totalCollected.toLocaleString()} ${fundingToken?.label}`}
      </Typography>
      <div className={classes.saleStatusContainer}>
        <div className={classes.salesStatusBarInnerContainer}>
          <div className={classes.salesStatusBar}>
            <div
              className={classes.salesStatusBarFilled}
              style={{
                width: percentage <= 100 ? `${percentage}%` : "100%",
                backgroundColor:
                  theme?.colors.poolCard?.statusBarFilled[fillBarColorId],
              }}
            />
          </div>
          <Typography variant="p" className={classes.currentPercText}>
            {hardCap ? percentage.toFixed(2) : "0.00"}%
          </Typography>
          {!pool.certified && (
            <div className={classes.thumbUpWrapper}>
              <ThumbUpSvg
                className={classes.voteUpIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowVoteModal(true);
                }}
              />
              <ThumbDownSvg
                className={classes.voteDownIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowVoteModal(true);
                }}
              />
            </div>
          )}
        </div>
        {!pool.certified && (
          <div className={classes.salesStatusSubBar}>
            <Typography variant="h5" className={classes.poolPercentageText}>
              {noVotes
                ? ((yesVotes / noVotes) * minYesVotesThreshold).toFixed(2)
                : "0.00"}
              % ‘Yes’ votes until minimum met.
            </Typography>
          </div>
        )}
      </div>

      <div className={classes.maximumConnectContainer}>
        <div className={classes.connectWrapper}>
          <p className={classes.connectText}>Goal</p>
          <Typography variant="p" className={classes.maxText}>
            {hardCap.toFixed(2)} {fundingToken?.label}
          </Typography>
        </div>
        <div className={classes.connectWrapper}>
          <p className={classes.connectText}>Connect</p>
          <div className={classes.connectIconsWrapper}>
            {pool.linkTelegram && (
              <TelegramSvg
                onClick={(e) => {
                  e.stopPropagation();
                  window.open("https://t.me/" + pool.linkTelegram);
                }}
              />
            )}
            {pool.linkWebsite && (
              <ATagSvg
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(pool.linkWebsite);
                }}
              />
            )}
          </div>
        </div>
      </div>

      <Status poolInfo={pool} />

      <VoteModal
        closeModal={() => {
          setShowVoteModal(false);
        }}
        modalOpen={showVoteModal}
        salesTitle={pool.saleTitle}
        onVote={onVote}
      />
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(PoolCard)));
